import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'allowedValues' })
export class AllowedValuesPipe implements PipeTransform {
  transform(lookupValues: any[], allowedValues: any[], key: string): any[] {
    return lookupValues.filter(lut => allowedValues && allowedValues.includes(lut[key]));
  }
}
